import React, { useEffect, useState } from 'react';
import { handleCheckout } from '../utils/checkout';
export function OfferStack() {
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 50);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <section id="purchase" className="bg-warm-mid py-20 md:py-28 px-4 border-t-4 border-green-600" data-id="element-123">
      <div className="max-w-4xl mx-auto" data-id="element-124">
        {/* Urgency banner with countdown */}
        <div className="bg-red-600 rounded-2xl p-6 md:p-8 mb-10 text-center shadow-xl relative overflow-hidden" data-id="element-125">
          <div className="absolute inset-0 bg-gradient-to-r from-red-700 via-red-600 to-red-700 animate-pulse opacity-30" data-id="element-126"></div>
          <div className="relative z-10" data-id="element-127">
            <p className="font-sans font-bold text-white text-lg md:text-xl uppercase tracking-widest mb-4" data-id="element-128">
              🔥 Limited-Time Offer 🔥
            </p>
            <div className="flex items-center justify-center gap-3 md:gap-4" data-id="element-129">
              <div className="bg-white/20 backdrop-blur-sm rounded-xl px-4 py-3 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-130">
                <span className="font-serif text-4xl md:text-5xl font-bold text-white block leading-none" data-id="element-131">
                  {minutes.toString().padStart(2, '0')}
                </span>
                <span className="font-sans text-[10px] md:text-xs text-white/80 uppercase tracking-wider mt-1 block" data-id="element-132">
                  Minutes
                </span>
              </div>
              <span className="text-white text-3xl md:text-4xl font-bold animate-pulse" data-id="element-133">
                :
              </span>
              <div className="bg-white/20 backdrop-blur-sm rounded-xl px-4 py-3 md:px-6 md:py-4 min-w-[70px] md:min-w-[90px]" data-id="element-134">
                <span className="font-serif text-4xl md:text-5xl font-bold text-white block leading-none" data-id="element-135">
                  {seconds.toString().padStart(2, '0')}
                </span>
                <span className="font-sans text-[10px] md:text-xs text-white/80 uppercase tracking-wider mt-1 block" data-id="element-136">
                  Seconds
                </span>
              </div>
            </div>
            <p className="font-sans text-white/90 text-sm md:text-base mt-4 font-medium" data-id="element-137">
              ⚡ This price won't last — grab it before time runs out
            </p>
          </div>
        </div>

        {/* Section header */}
        <div className="text-center mb-10" data-id="element-138">
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-black leading-tight mb-3" data-id="element-139">
            Get The Pawfect Shot MegaPack
          </h2>
          <p className="font-serif text-2xl md:text-3xl text-green-600 font-bold" data-id="element-140">
            + all 3 bonuses free today
          </p>
        </div>

        {/* Offer card */}
        <div className="bg-white rounded-3xl p-8 md:p-12 border-2 border-green-600 shadow-2xl relative" data-id="element-141">
          <div className="absolute -top-5 left-1/2 transform -translate-x-1/2 bg-green-600 text-white font-bold py-2 px-8 rounded-full shadow-lg text-base whitespace-nowrap tracking-wide" data-id="element-142">
            ✨ BEST VALUE — TODAY ONLY
          </div>

          <h3 className="font-sans text-xl md:text-2xl font-bold text-black mb-6 border-b border-gray-200 pb-4 mt-2" data-id="element-143">
            📦 What you'll receive today:
          </h3>

          <ul className="space-y-3 mb-8" data-id="element-144">
            {['6 Dog Photography Books', 'Bonus #1: 30 Sit-Snap-Shoot Cheat Sheets', 'Bonus #2: 7 Lightroom Editing Walkthroughs', 'Bonus #3: Photo Settings & Setup Guide for 119 Dog Photos', 'Instant digital access', 'One-time payment', 'Lifetime access'].map((item, index) => <li key={index} className="flex items-center" data-id="element-145">
                <span className="text-green-500 text-lg mr-3" data-id="element-146">✅</span>
                <span className={`font-sans text-base md:text-lg ${index < 4 ? 'font-bold text-black' : 'text-gray-600'}`} data-id="element-147">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Price block */}
          <div className="bg-gradient-to-b from-gray-50 to-white rounded-2xl p-6 md:p-8 text-center border border-gray-200 mb-8" data-id="element-148">
            <p className="font-sans text-gray-400 text-lg mb-1" data-id="element-149">
              Regular Price:{' '}
              <span className="line-through text-red-400" data-id="element-150">USD $89.99</span>
            </p>
            <p className="font-sans text-gray-800 text-xl font-bold mb-1 uppercase tracking-wide" data-id="element-151">
              Today Only:
            </p>
            <p className="font-serif text-6xl md:text-7xl font-bold text-green-600 mb-2" data-id="element-152">
              USD $13.99
            </p>
            <p className="font-sans text-xs text-gray-400 italic" data-id="element-153">
              *You'll be charged in your local currency
            </p>
          </div>

          {/* Buy button */}
          <button onClick={handleCheckout} className="w-full bg-green-600 hover:bg-green-700 text-white font-sans font-bold text-2xl md:text-3xl py-6 px-8 rounded-2xl shadow-lg transition-all duration-300 transform hover:-translate-y-1 uppercase mb-6 flex items-center justify-center text-center" data-id="element-154">
            👉 GET MY MEGAPACK TODAY
          </button>

          {/* Trust badges */}
          <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-sm font-sans font-medium text-gray-500" data-id="element-155">
            <span className="flex items-center gap-1" data-id="element-156">
              <span className="text-green-500" data-id="element-157">✔</span> Instant access
            </span>
            <span className="flex items-center gap-1" data-id="element-158">
              <span className="text-green-500" data-id="element-159">✔</span> One-time payment
            </span>
            <span className="flex items-center gap-1" data-id="element-160">
              <span className="text-green-500" data-id="element-161">✔</span> Digital download
            </span>
            <span className="flex items-center gap-1" data-id="element-162">
              <span className="text-green-500" data-id="element-163">✔</span> Lifetime access
            </span>
          </div>
        </div>
      </div>
    </section>;
}